export default __webpack_public_path__ + "static/media/SPPL_Financials_Dec_2023.b6482967.pdf";